module.exports = __webpack_public_path__ + "img/ico-grid-view.b702ca68.svg";